<template>
  <svg
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M4 13V12H21V13H4Z" />
    <path d="M4 13V12H21V13H4Z" />
    <path d="M12 4H13V21H12V4Z" />
    <path d="M12 4H13V21H12V4Z" />
  </svg>
</template>
